import CustomerSettingsPage from "./components/Settings/CustomerSettingsPage";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import HomeIcon from "@material-ui/icons/Home";
import CalendarIcon from "@material-ui/icons/PermContactCalendar";
import SettingsIcon from "@material-ui/icons/Settings";
import asyncComponent from "./components/common/asyncComponent";
import { Help } from "@material-ui/icons";
import HelpVideosPage from "./components/Help/HelpVideosPage";

const ApptWizardContainer = asyncComponent(() => import("./components/Wizard/ApptWizardContainer"));
const HomePage = asyncComponent(() => import("./components/HomePage/HomePage"));

export interface NavItem {
  hideInMenu?: boolean;
  title: string;
  path: string;
  exact: boolean;
  component: React.ComponentType;
  icon: React.ComponentType<SvgIconProps>;
}

const helpNavItem = {
  title: "Help",
  path: "/help",
  exact: false,
  component: HelpVideosPage,
  icon: Help
};

const newApptNavItem = {
  title: "New Appt",
  path: "/appt",
  exact: true,
  component: ApptWizardContainer,
  icon: CalendarIcon
};

const newApptHomeNavItem = {
  ...newApptNavItem,
  path: "/"
};

const homeNavItem = {
  title: "Home",
  path: "/",
  exact: true,
  component: HomePage,
  icon: HomeIcon
};

const settingsNavItem = {
  title: "Settings",
  path: "/settings",
  exact: true,
  component: CustomerSettingsPage,
  icon: SettingsIcon
};

export const defaultNavItems: NavItem[] = [newApptHomeNavItem, helpNavItem];

export const allNavItems: NavItem[] = [homeNavItem, newApptNavItem, settingsNavItem, helpNavItem];

export const internalNavItems: NavItem[] = [homeNavItem, newApptNavItem, helpNavItem];
